/*
===============================================================================================================
                                 Copyright 2022-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import PropTypes from 'prop-types';
import SendButton from '@/modules/emails/send-button';
import TextDiv from '../text-div';

export default function ResendActivationEmail({
  selectorId,
  title,
  merchantData,
}) {
  const requestBody = {
    companyId: merchantData?.companyId,
  };

  return (
    <>
      <div className="title">
        <TextDiv>
          {title}
        </TextDiv>
      </div>
      <SendButton
        id={selectorId}
        key={selectorId}
        requestData={requestBody}
        labelText={title}
        buttonText="resend"
        templateId="merchant_sign_up"
        showLabel={false}
        showBorder={false}
        fontSize="--font-size-button"
      />
      <style jsx>
        {`
          .title {
            font-size: var( --font-size-tooltip);
          }
        `}
      </style>
    </>
  );
}

ResendActivationEmail.defaultProps = {
  selectorId: null,
  title: null,
  merchantData: {},
};

ResendActivationEmail.propTypes = {
  selectorId: PropTypes.string,
  title: PropTypes.string,
  merchantData: PropTypes.shape({
    email: PropTypes.string,
    companyId: PropTypes.string,
  }),
};
